@if (line) {
  <div class="bg-primary-50 p-5 border-radius-4 shadow-4">
    <div class="row justify-content-sm-center">
      <div class="col-12 d-flex align-items-center justify-content-sm-center mb-3">
        <div class="d-flex align-items-center justify-content-center bg-secondary-{{line}}-500 circle-container-50">
          <span class="material-symbols-outlined filled mat-icon-size-40 primary-50 rotate-180" role="img">downloading</span>
        </div>
      </div>
      <div class="col-12 col-lg-6 text-sm-center">
        <p class="p-display-bold primary-900 mb-1">Subiendo novedades</p>
        <span class="p1-medium neutral-800">Actualizando proyectos. Pronto anunciaremos nuevas oportunidades.</span>
      </div>
    </div>
  </div>
}